export default __webpack_public_path__ + "static/media/MANEJO_DE_FLOTAS_CARACTERISTICAS_IMG.87c5d4f6.jpg";